import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SuiteHistoryNavbar } from "../Shared/SuiteHistoryNavbar";
import { Outlet } from "react-router-dom";
import {
  ImageAppHistoryItem,
  ImageSuiteApps,
  TextAppHistoryItem,
  TextSuiteApps,
} from "../../../Helper";
import {
  GetOptionsRequest,
  useDeleteImageSuiteHistoryById,
  useDeleteTextSuiteHistoryById,
  useGetImageSuiteHistory,
  useGetTextSuiteHistory,
} from "../../../store/Apis/SuitesApps/SuiteHistroyApi";
import { GenerateImgIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateImgIcon";
import { GenerateLogoIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateLogoIcon";
import { GenerateIconIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIconIcon";
import { GenerateIllsturationsIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIllsturationsIcon";
import { BgRemoverIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/BgRemoverIcon";
import { ImageRestoreIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageRestoreIcon";
import { ImageTranscaptionIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageTranscaptionIcon";
import { MicroPeopleIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/MIcroPeopleIcon";
import { TinyFigureIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/TinyFigureIcon";
import { ImageToPromptIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageToPromptIcon";
import { TranslatorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/TranslatorIcon";
import { HumanizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/HumanizeIcon";
import { SummarizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/SummarizeIcon";
import { ParaphraseIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/ParaphraseIcon";
import { TitleGeneratorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/TitleGeneratorIcon";
import { PromptEngineerIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/PromptEngineerIcon";
import "./SuiteHistory.css";
import {
  useDeleteVideoSuiteHistoryById,
  useGetVideoSuiteHistory,
} from "../../../store/Apis/SuitesApps/VideoSuiteHistoryApi";
import { VideoHistoryData } from "../../../Types/VideoSuite-Types";
import { useGetUserCredits } from "../../../store/Apis/StripeApi";
import { ImageToImageIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageToImageIcon";

export const returnAppIcon = (appName: string) => {
  switch (appName) {
    case ImageSuiteApps.ImageGenerator:
      return <GenerateImgIcon className="history-item-icon" />;
    case ImageSuiteApps.LogoGenerator:
      return <GenerateLogoIcon className="history-item-icon" />;
    case ImageSuiteApps.IconGenerator:
      return <GenerateIconIcon className="history-item-icon" />;
    case ImageSuiteApps.IllustrationGenerator:
      return <GenerateIllsturationsIcon className="history-item-icon" />;
    case ImageSuiteApps.BackgroundRemover:
      return <BgRemoverIcon className="history-item-icon-stroke" />;
    case ImageSuiteApps.ImageRestore:
      return <ImageRestoreIcon className="history-item-icon-stroke" />;
    case TextSuiteApps.TextExtraction:
      return <ImageTranscaptionIcon className="history-item-icon-stroke" />;
    case ImageSuiteApps.MicroPeople:
      return <MicroPeopleIcon className="history-item-icon-stroke" />;
    case ImageSuiteApps.TinyFigures:
      return <TinyFigureIcon className="history-item-icon-stroke" />;
    case TextSuiteApps.ImageToPrompt:
      return <ImageToPromptIcon className="history-item-icon-stroke" />;
    case ImageSuiteApps.ImageToImage:
      return <ImageToImageIcon className="history-item-icon" />;
    case TextSuiteApps.Translator:
      return <TranslatorIcon className="history-item-icon" />;
    case TextSuiteApps.Humanizer:
      return <HumanizeIcon className="history-item-icon-stroke" />;
    case TextSuiteApps.Summarizer:
      return <SummarizeIcon className="history-item-icon" />;
    case TextSuiteApps.Paraphraser:
      return <ParaphraseIcon className="history-item-icon" />;
    case TextSuiteApps.TitleGenerator:
      return <TitleGeneratorIcon className="history-item-icon" />;
    case TextSuiteApps.PromptGenerator:
      return <PromptEngineerIcon className="history-item-icon" />;
    default:
      return;
  }
};

export const SuiteHistoryView = () => {
  const [getTextSuiteHistoryFilters, setGetTextSuiteHistoryFilters] = useState<GetOptionsRequest>();
  const [getImageSuiteHistoryFilters, setGetImageSuiteHistoryFilters] = useState<GetOptionsRequest>();
  const [getVideoSuiteHistoryFilters, setGetVideoSuiteHistoryFilters] = useState<GetOptionsRequest>();
  const {
    data: TextSuiteHistoryData,
    isSuccess: isSuccessTextSuiteHistory,
    isPending: isTextSuiteHistoryLoading,
  } = useGetTextSuiteHistory(getTextSuiteHistoryFilters);
  const {
    refetch: GetImageSuiteHistory,
    data: ImageSuiteHistoryData,
    isSuccess: isSuccessImageSuiteHistory,
    isPending: isImageSuiteHistoryLoading,
  } = useGetImageSuiteHistory(getImageSuiteHistoryFilters);
  const {
    mutate: DeleteTextItem,
    isSuccess: isTextItemDeleted,
    isPending: isDeleteTextItemLoading,
  } = useDeleteTextSuiteHistoryById();
  const {
    mutate: DeleteImageItem,
    isSuccess: isImageItemDeleted,
    isPending: isDeleteImageItemLoading,
  } = useDeleteImageSuiteHistoryById();
  const {
    mutate: deleteVideo,
    isPending: isDeleteVideoItemLoading,
  } = useDeleteVideoSuiteHistoryById();
  const {
    data: allVideosSuiteHistory,
    isPending: isVideoHistoryLoading,
  } = useGetVideoSuiteHistory(getVideoSuiteHistoryFilters);
  const [imageSuiteHistoryItems, setImageSuiteHistoryItems] = useState<
    ImageAppHistoryItem[] | null
  >(null);
  const [textSuiteHistoryItems, setTextSuiteHistoryItems] = useState<
    TextAppHistoryItem[] | null
  >(null);

  const [videoSuiteHistoryItems, setVideoSuiteHistoryItems] = useState<
    VideoHistoryData[] | null
  >(null);
  const getUserCredits = useGetUserCredits();
  const Props = {
    ImageAppHistoryItems: imageSuiteHistoryItems,
    TextAppHistoryItems: textSuiteHistoryItems,
    VideoAppHistoryItems: videoSuiteHistoryItems,
    DeleteTextItem: DeleteTextItem,
    DeleteImageItem: DeleteImageItem,
    DeleteVideoItem: deleteVideo,
    GetImageSuiteHistory: GetImageSuiteHistory,
    isImageSuiteHistoryLoading: isImageSuiteHistoryLoading,
    isTextSuiteHistoryLoading: isTextSuiteHistoryLoading,
    isDeleteImageItemLoading: isDeleteImageItemLoading,
    isImageItemDeleted: isImageItemDeleted,
    isDeleteTextItemLoading: isDeleteTextItemLoading,
    isDeleteVideoItemLoading: isDeleteVideoItemLoading,
    isVideoHistoryLoading: isVideoHistoryLoading,
    isSuccessTextSuiteHistory: isSuccessTextSuiteHistory,
    isSuccessImageSuiteHistory: isSuccessImageSuiteHistory,
    isTextItemDeleted:isTextItemDeleted,
    setVideoSuiteHistoryItems: setVideoSuiteHistoryItems,
  };

  useEffect(() => {
    setGetTextSuiteHistoryFilters({});
    setGetImageSuiteHistoryFilters({});
    setGetVideoSuiteHistoryFilters({});
  }, []);

  useEffect(() => {
    if (
      TextSuiteHistoryData ||
      ImageSuiteHistoryData ||
      allVideosSuiteHistory
    ) {
      setImageSuiteHistoryItems(ImageSuiteHistoryData);
      setTextSuiteHistoryItems(TextSuiteHistoryData);
      setVideoSuiteHistoryItems(allVideosSuiteHistory ?? []);
    }
  }, [TextSuiteHistoryData, ImageSuiteHistoryData, allVideosSuiteHistory]);

  return (
    <Box className="suite-history-view">
      <SuiteHistoryNavbar
        textAppItems={Props.TextAppHistoryItems}
        imageAppItems={Props.ImageAppHistoryItems}
        videoAppItems={Props.VideoAppHistoryItems ?? []}
        getTextHistoryItems={setGetTextSuiteHistoryFilters}
        getImageHistoryItems={setGetImageSuiteHistoryFilters}
        getVideoHistoryItems={setGetVideoSuiteHistoryFilters}
      />
      <Outlet context={Props} />
    </Box>
  );
};
